<template>
    <div class="settlement" >
        <el-card >
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>结算管理</el-breadcrumb-item>
                <el-breadcrumb-item>结算单</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="开票日期">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"  clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="已申请" value="0"></el-option>
                            <el-option label="已开票" value="1"></el-option>
                            <el-option label="已结算" value="2"></el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    size="mini"
                    style="width: 100%">

                    <el-table-column
                        prop="settlementNo"
                        label="结算单号" width="220">
                    </el-table-column>
                    <el-table-column
                        prop="companyName"
                        label="公司名称" width="250">
                    </el-table-column>
                    <el-table-column
                        prop="totalPrice"
                        label="开票金额(元)" width="120">
                    </el-table-column>

                     <el-table-column
                            prop="createTime"
                            label="创建时间" width="200" align="center">
                     </el-table-column>
                     <el-table-column
                            fixed="right"
                            prop="status"
                            label="状态"
                            width="100" align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0">已申请</el-tag>
                            <el-tag v-if="scope.row.status == 1">已开票</el-tag>
                            <el-tag v-if="scope.row.status == 2">已结算</el-tag>
                         </template>
                     </el-table-column>

                    <el-table-column label="操作" width="200" align="right" fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text"
                                @click="handleToReviewDetail(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

    </div>
</template>
<script>
export default {

    data() {
        return {

            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            money: 0,
            invoiceList:[],
            addressList:[],
            reviewVisible:false,
            searchForm: {
                timeDate: "",
                status: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },

            orderForm: {
                orderBatch: "",
            },
            reviewForm: {
                id:"",
                companyId:"",
                invoiceId:"",
                companyName:"",//
                bankName:"",//
                bankAccount:"",//
                companyTaxNo:"",//
                registeredTel:"",//
                registeredAddress:"",//

            },
            addressId:"",
            addressForm: {
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town:""
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""//

            },
            selectData:[],//选中的数据
            rules: {
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                consignee: [
                    { required: true, message: '请输入收件人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],

            },
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this;
            let cond = {...this.searchForm};
            if(!this.searchForm.status) {
                cond['status'] = undefined;
            }
            if(this.searchForm.timeDate != "" &&this.searchForm.timeDate!=null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.$axios.post("/admin/invoice/settlementList",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        judgeSelect(row){
            return row.isInvoice == false // 返回true该行可选，返回false则不可选
        },
        selectChanged(invoiceId) {
            if(invoiceId != null && invoiceId != ""){

                let one = null;
                for(let i=0;i<this.invoiceList.length;i++){
                    let item = this.invoiceList[i];
                    if(item.id == invoiceId){
                        one = item;
                    }
                }
                if(one != null) {
                    this.reviewForm = one;
                    this.reviewForm.invoiceId = invoiceId;
                }

            }else{
                this.reviewForm = {};
                this.reviewForm.invoiceId = "";
            }

        },
        addressChanged(addressId) {
            this.addressId = '';
            this.addressId = addressId;
            //this.$set(this.addressForm, 'id', '')
           // this.$set(this.addressForm,'id',addressId);
           // this.$forceUpdate();
            if(addressId != null && addressId != ""){

                let one = null;
                for(let i=0;i<this.addressList.length;i++){
                    let item = this.addressList[i];
                    if(item.id == addressId){
                        one = item;
                    }
                }
                if(one != null){
                    this.addressForm = one;
                    let region = {};
                    if(one.provinceId != null){
                        region.province = one.provinceId;
                    }
                    if(one.cityId != null){
                        region.city = one.cityId;
                    }
                    if(one.countyId != null){
                        region.area = one.countyId;
                    }
                    region.town = '';
                    this.addressForm.region = region;
                }


            }else{

                // this.addressForm.id = addressId;
                // this.addressForm.region = {province:"",city:"",area:"",town:""};
                // this.$set(this.addressForm, this.addressForm.id, '');
                this.addressForm = {
                    region: {
                        province: '',
                            city: '',
                            area: '',
                            town:""
                    },
                    id:"",
                        mobile:"",
                        address:"",//
                        consignee:"",//
                        county:"",//
                        city:"",//
                        province:"",//
                        provinceId:"",//
                        cityId:"",//
                        countyId:""//

                }


            }
            //this.$set(this.addressForm,'id',addressId);

        },
        loadInvoice(){
            let _this = this
            this.$axios.post("/admin/invoice/customer/list"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.invoiceList = resp.data;
                }

            });

        } ,
        loadAddress(){
            let _this = this
            this.$axios.get("/admin/address/getAddress"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.addressList = resp.data;
                }

            });

        } ,
        regionChange (data) {

            //{"province":{"key":"130000","value":"河北省"},"city":{"key":"130100","value":"石家庄市"},"area":{"key":"130105","value":"新华区"}}

            if(data.province != null){
                this.addressForm.province = data.province.value;
                this.addressForm.provinceId = data.province.key;
            }

            if(data.city != null){
                this.addressForm.city = data.city.value;
                this.addressForm.cityId = data.city.key;
            }
            if(data.area != null){
                this.addressForm.county = data.area.value;
                this.addressForm.countyId = data.area.key;
            }

        },
        saveAddress() {
            const that = this;
            this.$refs.addressForm.validate(valid => {
                if(valid) {
                    this.$axios.post("/admin/address/save", this.addressForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                // that.$notify({
                                //     title: '成功',
                                //     message: '数据保存成功',
                                //     type: 'success'
                                // });
                                that.addressId = resp.data.id;
                                that.saveSettlement();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            });
        },

        showReviewDialog() {//打开发票对话框
            this.reviewForm =
                {
                    id: "",
                    companyId: "",
                    invoiceId: "",
                    companyName: "",//
                    bankName: "",//
                    bankAccount: "",//
                    companyTaxNo: "",//
                    registeredTel: "",//
                    registeredAddress: ""
                };
            this.clearIt();
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要开发票的订单',
                    duration: 2000
                });
                return;
            }
            this.loadInvoice();
           // if(this.addressList.length==0){
                this.loadAddress();
           // }
            //this.loadAddress();
            this.money = 0;
            this.selectData.map(it => {this.money = this.money+it.totalPrice});
            if(this.money){
                this.money = this.money.toFixed(2);
            }
            this.reviewVisible = true;

        },
        clearIt(){
            this.addressId = "";
            this.addressForm={
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town: ''
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""

            }

        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        saveSettlement(){
            const that = this;
            let data = {};
            data.invoiceId = this.reviewForm.invoiceId;
            data.addressId = this.addressId;

            let ids =  this.selectData.map(it => it.id);
            data.orderIds = ids;
            data.companyId = this.reviewForm.companyId;
            data.companyName = this.reviewForm.companyName;

            this.$axios.post("/admin/invoice/saveSettlement", data)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.onSearch();
                        that.reviewVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        addVoice(){//确定开发票

            if(this.reviewForm.invoiceId=="" ||this.reviewForm.invoiceId == null ){
                this.$message({
                    type: 'info',
                    message: '请选择发票',
                    duration: 1000
                });
                return;
            }
            if(this.addressId=="" ||this.addressId == null ){
                this.saveAddress();

            }else{
                this.saveSettlement();
            }
        },

        handleToReviewDetail(row) {


            this.$router.push({name: "settlementDetail", params: {from: "settlement", settlementNo: row.settlementNo,
                    id:row.id,totalPrice:row.totalPrice,code:row.code,companyName:row.companyName,createTime:row.createTime}})




        },

        handleSelectionChange(val) {
            this.selectData = val;
        },


    },

    created() {

        this.onSearch();
        this.loadAddress();

    },
}
</script>
<style>

    .item {

        margin-bottom: 0px;

    }
    .item1 {
        margin-top: -10px;
        margin-bottom: 0px;

    }
</style>